import { useState } from "react"
import { DetailPage, Row } from "../../components/crud/DetailPage"
import { FkLink, ListPage } from "../../components/crud/ListPage"
import { AsyncSelect, Checkbox, DateInput, MoneyInput, TextInput } from "../../components/forms/Inputs"
import { useOptions } from "../../hooks/useOptions"
import { useTranslations } from "../../layers/Localization"
import { Currency } from "../../hooks/helpers"

function TravauxPonctuelsFields({ item, set, tab }) {
    const [client, setClient] = useState()

    const t = useTranslations()
    const clientOptions = useOptions('clients', ['num', 'referenceCourte'])
    const fournisseursOptions = useOptions('fournisseurs', 'nom')

    const onNomChange = value => {
        set('nom')(value.toUpperCase())
    }
    const onDateChange = value => {
        set('date')(value)
        set('nom')((item.nom || "").trim().replace(/ \([a-zA-Z ]+ [0-9]{2}\/[0-9]{2}\)$/, '') + (value
            ? ` (${t('FAIT LE {date}', { date: String(value.getUTCDate()).padStart(2, '0') + '/' + String(value.getUTCMonth() + 1).padStart(2, '0') }, client?.langue || 'FR')})`
            : ''
        ))
    }

    const invalidRealise = item.fournisseurId
        ? (item.realise && (!item.date || item.prixAchat == null || item.prixVente == null) ? t("Impossible de terminer le travail sans date, prix d'achat et prix de vente") : "")
        : (item.realise && (!item.date || item.prixVente == null) ? t("Impossible de terminer le travail sans date et prix de vente") : "")

    return <>
        <Row>
            <AsyncSelect label={t("Client")} value={item.clientId} onChange={set('clientId')} onItemLoad={setClient} options={clientOptions} required />
            <AsyncSelect label={t("Fournisseur")} value={item.fournisseurId} onChange={set('fournisseurId')} options={fournisseursOptions} />
        </Row>
        <TextInput className="grow" label={t("Désignation")} value={item.nom} onChange={onNomChange} required />
        <Row>
            <DateInput label={t("Date")} value={item.date} onChange={onDateChange} />
            <MoneyInput label={t("Prix d'achat")} value={item.prixAchat} onChange={set('prixAchat')} />
            <MoneyInput label={t("Prix de vente")} value={item.prixVente} onChange={set('prixVente')} />
        </Row>
        <Checkbox label={t("Réalisé")} value={item.realise} onChange={set('realise')} invalid={invalidRealise} />
        <Checkbox label={t("Facture d'achat reçue")} value={item.factureAchat} onChange={set('factureAchat')} />
    </>
}

export function TravauxPonctuelsList(props) {
    const t = useTranslations()
    return <ListPage model="travauxPonctuels" title={t("Travaux ponctuels")} columns={{
        [t('Client')]: { sort: 'client', value: item => <FkLink>{item.client?.referenceCourte}</FkLink> },
        [t('Fournisseur')]: { sort: 'fournisseur', value: item => <FkLink>{item.fournisseur?.nom}</FkLink> },
        [t('Date')]: 'date',
        [t('Nom')]: 'nom',
        [t("Prix d'achat")]: { sort: 'prixAchat', value: item => <Currency value={item.prixAchat} /> },
        [t('Prix de vente')]: { sort: 'prixVente', value: item => <Currency value={item.prixVente} /> },
        [t('Réalisé')]: 'realise'
    }} join={{
        'client': 'referenceCourte',
        'fournisseur': 'nom',
    }} filter={{
        [t('En cours')]: 'realise=false',
        [t('A facturer')]: 'realise=true&facturesDetails:none=',
        [t('Facture à recevoir')]: 'realise=true&factureAchat=false',
        [t('Tous')]: '',
    }} {...props} />
}

export function TravauxPonctuelsDetail(props) {
    const t = useTranslations()
    return <DetailPage model="travauxPonctuels" title={t("Travail ponctuel")} Fields={TravauxPonctuelsFields} {...props} />
}
